const { drugIdAvailability } = require('@/api/siterequest')
const { returnableDrugs } = require('@/api/returned')

import user from '../../store/modules/user'

export default {
  'entityName': 'siterequest_has_drug',
  id: ['siterequest_id', 'drug_id'],
  'title': 'Drugs',
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'siterequest.id',
    'descending': true
  },
  'fields': [
    {
      'value': '_drug_id',
      'text': 'Drug',
      'title': 'name',
      filter: item => ({ id: item.drug_id }),
      subtitle: drug =>  drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      'table': {
        'text': 'drug.name'
      },
      render: (item) => {
        const drug = item.drug
        item.multiplier = item.drug.multiplier
        return drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `
      },
      readonly: true
    },
    // },
    {
      'value': 'n_pieces',
      'text': 'N. requested',
      'type': 'number',
      'table': {
        'sortable': true,
        'filter': false
      },
      slim: true,
      readonly: true,
      // 'validators': [
      //   'required',
      //   'number',
      //   (field, value, item) => value%item.multiplier===0 || `${field.text} has to be a multiplier of ${item.multiplier}`
      // ]
    },
    {
      'value': '_n_available',
      type: 'hidden',
      deps: ['_drug_id'],
      default: async (item) => {
        const drug_id = item.drug.id
        const always_available = item.drug.always_available
        if (!always_available) {
          if (item.siterequest.is_transfer) {
            const drugs = await returnableDrugs(item.drug.name, item.siterequest.protocol_id, item.siterequest.site_source_id)
            const drug = drugs?.data?.find(d => d.drug_id === item.drug.id)
            return drug?.n_available
          }
          const ret = await drugIdAvailability(drug_id, item.siterequest.id)
          return ret?.data[0] ? ret.data[0].n_pieces : 0
        }
        return 0
      }
    },
    {
      slim: true,
      value: 'n_confirmed',
      text: 'N. confirmed',
      type: 'number',
      table: {
        sortable: true,
        filter: false
      },
      deps: ['n_pieces', '_n_available'],
      default: item => item.n_pieces,
      validators: [
        // 'required',
        'number',
        (field, value, item) => {
          // do not check multiplier for administrator (probably not needed as this view is for admin only)
          if (['Administrator', 'EMN User'].includes(user.state.role)) return true
          return item.siterequest.site_source_id > 0 || item.multiplier === 0 || value%item.multiplier===0 || `${field.text} has to be a multiplier of ${item.multiplier}`
        },
        (_field, value, item) => !!item.drug.always_available || value <= item._n_available || `Only ${item._n_available} ${item.siterequest.is_transfer ? 'in source site' : 'in stock'}`
      ]
    }
  ],
  actions: [
    'upsert'
  ]
}
